import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Button, Card, CardBody, CardFooter} from "reactstrap";
import classnames from "classnames";


class Answer extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {

    };

    this.isDisabled = this.isDisabled.bind(this);
    this.handlerOnClick = this.handlerOnClick.bind(this);
  }

  handlerOnClick(){
    if(!this.isDisabled()){
      this.props.onChoose();
    }
  }

  isDisabled(){
    const {answer, value} = this.props;

    return value >= answer.maxValue || value <= answer.minValue;
  }

  render() {
    const {answer, value, question} = this.props;

    return (
      <Card className={classnames({
        'answer': true,
        'disabled': this.isDisabled()
      })} onClick={() => this.handlerOnClick()}>
        <CardBody>
          {answer.content}
        </CardBody>
        <CardFooter className="text-center py-1">
          {value.toFixed(2)} {question.currency}
        </CardFooter>
      </Card>
    );
  }
}

Answer.propTypes = {
  answer: PropTypes.shape({
    content: PropTypes.string.isRequired,
  }).isRequired,
  question: PropTypes.object.isRequired,
  value: PropTypes.number.isRequired,
  onChoose: PropTypes.func.isRequired,
};

export default Answer;